import { TableModel, tableModelFactory } from "../table-model-factory";

export interface EnrollmentActivitySummaryModel extends TableModel {}

export function getEnrollmentActivitySummaryModel(): EnrollmentActivitySummaryModel {
  return {
    ...tableModelFactory(
      "enrollmentActivitySummary",
      "enrollment_activity_summary/last_7_days",
      getEnrollmentActivitySummaryRowId
    ),
  };
}

function getEnrollmentActivitySummaryRowId(row) {
  return [
    row.eLMSID.toString(),
    row.ActivityID.toString(),
    row.ActivityStartDate.toString(),
  ].join("|");
}
